import React from "react";
import { Space, Typography } from "antd";
import ItemizedJobCard from "components/jobs/ItemizedJobCard";
import DateRangeStart from "components/jobs/DateRangeStart";
import useApiKeyCheck from "hooks/useApiKeyCheck";
import { apiKeyNotice, apiKeyTags } from "pages/jobs/apiKeyStatus";
import { BatchJobItem } from "reducers/types";
import { rangeLabel } from "pages/jobs/rangeLabel";

interface Props {
  /** Whether the server has CMC_API_KEY loaded; undefined while unknown. */
  keyLoaded?: boolean;
}


const cmcDetails = (item: BatchJobItem) => {
  const d = item.details;
  if (!d) {
    return null;
  }
  return (
    <Typography.Text type="secondary">
      written {d.written} / fetched {d.fetched}
      {d.reverse > 0 ? ` · ${d.reverse} reverse` : ""}
      {d.unmapped > 0 ? ` · ${d.unmapped} unmapped` : ""}
      {d.carried > 0 ? ` · ${d.carried} carried` : ""}
      {d.documentCreated > 0 ? ` · ${d.documentCreated} created` : ""}
      {d.kept > 0 ? ` · ${d.kept} kept` : ""}
    </Typography.Text>
  );
};

// CoinMarketCap history for a date range, processed date by date on the server (job type cmc-history).
const CmcHistoryCard: React.FC<Props> = ({ keyLoaded }) => {
  const check = useApiKeyCheck("cmc", keyLoaded === true);
  return (
    <ItemizedJobCard
      title={
        <Space>
          Crypto (CoinMarketCap) Parity History
          {apiKeyTags(keyLoaded, check)}
        </Space>
      }
      basePath="/admin/resources/update/cmc/history"
      start={({ start }) =>
        apiKeyNotice("CMC_API_KEY", "CoinMarketCap", keyLoaded, check) || <DateRangeStart onStart={start} onlyPast withOverride />
      }
      renderLabel={rangeLabel}
      renderDetails={cmcDetails}
    />
  );
};

export default CmcHistoryCard;
